<template src="./assetcheckviewdata.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import DeleteImage from "@/pages/operations/deleteimage/deleteimage";
  var moment = require("moment");

  export default {
    components: { DeleteImage },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
     
    },
    props: ["AssetCheckSubmitId", "type"],
    data() {
      return {
        ShowLoader: false,
        PopupLoader: false,
        AssetChecks: [],
        CompanyChecks: [],
        CompanyLogo: "",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        biglightgallery: [],
        showLocationDetails: false,
        infoOpened: false,
        locationPoints: "",
        AssetCheckDuration:false,
        center: {
          lat: 55.232753,
          lng: -3.944403,
        },
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
          content: "",
        },
        ShowFailedCheckModel: false,
        FailedChecks: [],
        SafeNotes: "",
        date_fixed: "",
      };
    },
    mounted() {
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions.Asset ||
          !AccountPermissions["Asset Checks"] ||
          !AccountPermissions["Asset Checks"]["enable"])
      ) {
        //this.$router.push("/");
      }
      document.title = pbx_SiteTitle + " - Assets Check View";
      setTimeout(() => {
        this.GetAssetChecksList();
      }, 800);

      var Company = JSON.parse(localStorage.getItem("Company"));
      if (Company) {
        this.CompanyLogo = Company.logo;
      }
        var CompanySettingsKey = JSON.parse(localStorage.getItem("Company") );
    if(CompanySettingsKey.fleet_settings_key != "undefined"){
      CompanySettingsKey = JSON.parse(CompanySettingsKey.fleet_settings_key);
      if (CompanySettingsKey != null && typeof CompanySettingsKey.AssetCheckDuration != "undefined" && CompanySettingsKey.AssetCheckDuration) {
        this.AssetCheckDuration = CompanySettingsKey.AssetCheckDuration;
      }
    }
    },
    methods: {
       removenlbr: function (data) {
        if (!data) return ''
        return data.replace(/(\r\n|\n|\r)/gm, '')
      },
      ShowLocationMap(CheckDetails) {
      this.showLocationDetails = true;
      if(!CheckDetails?.latitude || !CheckDetails?.longitude){
        return;
      }
      const marker = {
        lat: parseFloat(CheckDetails.latitude),
        lng: parseFloat(CheckDetails.longitude),
      };
      this.center = marker,
      this.locationPoints = marker;
      this.infoOpened = true;
      this.infoOptions.content =
        '<div id="mapcontent"><h5 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
          (CheckDetails?.asset?.name || '') +
        "</h5></div>";
    },

      LoadProfileData() {
        this.GetAssetChecksList();
      },
      SearchAsset() {
        this.GetAssetChecksList();
      },
      GeneratePDF() {
        $("#save_pdf_btn").html("Processing...");
        this.$root.$emit("GeneratePDF");
      },
      GetAssetChecksList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        obj.assetCheckSubmitId = this.AssetCheckSubmitId;
        this.ShowLoader = true;
        Axios.post(Endpoints.Assets.Checks.Details, obj).then(
          (Response) => {
            this.ShowLoader = false;
            if (Response?.data?.success) {              
              this.AssetChecks = Response.data.FleetCheckSubmit;
              this.CompanyChecks = Response.data.CompanyChecks;
              if(this.AssetChecks?.value){
                this.AssetChecks.value.forEach((element) => {
                  if (Array.isArray(element?.photo) && element.photo.length > 0) {
                    element.photo.forEach((photo) => {
                      this.biglightgallery.push(this.ImageEndpoint + photo);
                    });
                  }
                });   
                if(this.AssetChecks?.latitude && this.AssetChecks.latitude != "" && this.AssetChecks.latitude != null ){
                  this.ShowLocationMap(this.AssetChecks);
                }
              }
            } else {
              this.$router.push("/error-500");
            }
          });
      },
      MarkSafe() {
        this.ShowFailedCheckModel = true;
        var obj = { token: localStorage.getItem("token") };
        obj.assetCheckSubmitId = this.AssetCheckSubmitId;
        this.ShowLoader = true;
        Axios.post(Endpoints.Assets.Checks.GetAssetFailedCheck, obj).then((Response) => {
            this.ShowLoader = false;
            if (Response?.data?.success) {
                this.FailedChecks = Response.data.FailedChecks;
            }
        });
      },
      MarkSafeSubmit(){
        if(this.SafeNotes == "") {
            this.$swal("Following Error Found!", "Please Enter Notes", "error").then(() => {});
        }else if(this.date_fixed == "") {
            this.$swal("Following Error Found!", "Please Enter Date Fixed", "error").then(() => {});
        }else{            
            var obj = { token: localStorage.getItem("token") };
            obj.assetCheckSubmitId = this.AssetCheckSubmitId;
            obj.date_fixed = this.date_fixed;
            obj.notes = this.SafeNotes;
            this.PopupLoader = true;
            Axios.post(Endpoints.Assets.Checks.marksafe, obj).then((Response) => {
                  this.PopupLoader = false;
                  if (Response?.data?.success) {                      
                      this.ShowFailedCheckModel = false;
                      this.$swal("Asset Check Marked Safe Successfully", "", "success").then(() => {
                        window.location.reload();  
                      });
                  }
            })
        }
      },    
    },
  };
</script>
<style scoped>
  .position-relative {
    position: relative;
  }
  .logomain {
    max-width: 50%;
  }
</style>
